import { useAquariumRouteSync } from '../../hooks/useAquariumRouteSync';

/**
 * Mounts useAquariumRouteSync once for the lifetime of the app. Must be
 * rendered inside <BrowserRouter> (for useNavigate/useLocation) and inside
 * ActiveAquariumDataProvider (for the active aquarium it watches) — see
 * App.tsx. Renders nothing.
 */
export function AquariumRouteSync(): null {
  useAquariumRouteSync();
  return null;
}

export default AquariumRouteSync;
